var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImprovedPerformanceCarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.39636C10.1527 5.39636 5.39636 10.1527 5.39636 16C5.39636 21.8473 10.1527 26.6036 16 26.6036C21.8473 26.6036 26.6036 21.8473 26.6036 16C26.6036 10.1527 21.8473 5.39636 16 5.39636ZM22.1818 14.2691L21.2218 19.8691C21.1636 20.1891 20.8873 20.4218 20.5673 20.4218H11.4327C11.1127 20.4218 10.8364 20.1891 10.7782 19.8691L9.81818 14.2691C9.77454 14.0218 9.87636 13.7745 10.08 13.6291C10.2836 13.4836 10.5455 13.4545 10.7636 13.5709L13.3236 14.8218L15.4182 11.04C15.6509 10.6182 16.3491 10.6182 16.5818 11.04L18.6764 14.8073L21.2364 13.5564C21.4545 13.4545 21.7309 13.4691 21.92 13.6145C22.1236 13.7745 22.2255 14.0218 22.1818 14.2691Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprovedPerformanceCarIcon);
export default __webpack_public_path__ + "static/media/improved_performance_car_icon.bda920d8c31a694b4242cdf3f9624484.svg";
export { ForwardRef as ReactComponent };